/**
 * Query keys do módulo fiscal (cadastro F1: config do clube, perfis de
 * serviço/produto, mapa de origem, catálogo de modelos, resumo dos produtos).
 * Mutações do cadastro invalidam `qk.fiscal.all`; as que mexem em produto
 * invalidam também `qk.pdv.productsAll`.
 */
import { tuple } from "./core";

const root = ["fiscal"] as const;

export const fiscal = {
  /** Prefixo raiz — mutações do cadastro fiscal invalidam isto. */
  all: root,
  /** Linha de `club_fiscal_config` do clube. */
  config: (clubId: string | null | undefined) => tuple(root, "config", clubId),
  /** Perfis de serviço (NFS-e) do clube. */
  perfisServico: (clubId: string | null | undefined) => tuple(root, "perfisServico", clubId),
  /** Perfis de produto (NFC-e) do clube. */
  perfisProduto: (clubId: string | null | undefined) => tuple(root, "perfisProduto", clubId),
  /** Mapa origem da receita → perfil de serviço. */
  mapaOrigem: (clubId: string | null | undefined) => tuple(root, "mapaOrigem", clubId),
  /** Contagem fiscal dos produtos ativos (sem NCM / sem perfil). */
  resumoProdutos: (clubId: string | null | undefined) => tuple(root, "resumoProdutos", clubId),
  /** Prefixo das notas emitidas — emitir/cancelar/reenviar invalidam isto. */
  documentosAll: tuple(root, "documentos"),
  /** Lista paginada de `club_documentos_fiscais`. */
  documentos: (clubIds: readonly string[], filtros: unknown, page: number) =>
    tuple(root, "documentos", [...clubIds].sort().join(","), filtros, page),
  /** A nota viva de uma origem (fatura/venda), para o recibo e a linha. */
  documentoDaOrigem: (origemId: string | null | undefined) => tuple(root, "documentos", "origem", origemId),
  /** Clubes com a emissão nova ligada (nfse_ativa/nfce_ativa). */
  clubesComEmissao: (clubIds: readonly string[], tipo: "nfse" | "nfce") =>
    tuple(root, "clubesComEmissao", [...clubIds].sort().join(","), tipo),
  /**
   * Admin da PPS (rota /nfse): notas de todos os clubes e da PlayPro como
   * emissora. Reenviar/cancelar/conectar/ativar invalidam `adminAll`.
   */
  admin: {
    all: tuple(root, "admin"),
    documentos: (filtros: unknown, page: number, pageSize: number) =>
      tuple(root, "admin", "documentos", filtros, page, pageSize),
    resumoDasNotas: (filtros: unknown) => tuple(root, "admin", "resumoDasNotas", filtros),
    resumoDosClubes: (inicio: string, fim: string) => tuple(root, "admin", "resumoDosClubes", inicio, fim),
    emissorPlataforma: tuple(root, "admin", "emissorPlataforma"),
  },
} as const;
